import request from '../../request.js'
//e签宝 会员认证

// 会员认证，获取手机验证码 - 张卫华
export const sendSingleSms = function (data) {
    return request({
        url: '/smsInfo/sendSingleSms',
        method: 'post',
        data
    })
}

// 检查验证码是否有效 - 张卫华
export const checkSingleSms = function (data) {
    return request({
        url: '/smsInfo/checkSingleSms',
        method: 'post',
        data
    })
}

// 发起会员认证-- 郑勇
export const startValidate = function (data) {
    return request({
        url: '/esignUser/startValidate',
        method: 'post',
        data
    })
}

//获取分页列表信息 -- 张卫华
export const getPageTableList = function (data) {
    return request({
        url: '/esignUser/getPageTableList',
        method: 'post',
        data
    })
}

//更新/保存 -- 张卫华
export const saveOrUpdate = function (data) {
    return request({
        url: '/esignUser/saveOrUpdate',
        method: 'post',
        data
    })
}

//根据id，获取信息 -- 张卫华
export const getObjectById = function (data) {
    return request({
        url: '/esignUser/getObjectById',
        method: 'post',
        data
    })
}

//根据id，删除 -- 张卫华
export const deleteById = function (data) {
    return request({
        url: '/esignUser/deleteById',
        method: 'post',
        data
    })
}

//根据手机号码，获取信息 -- 张卫华
export const getObjectByMobileNo = function (data) {
    return request({
        url: '/esignUser/getObjectByMobileNo',
        method: 'post',
        data
    })
}
